import React from "react";
import { officeHours } from "../views/customer/customerEnquiry/utils";

import "./contactUsCard.scss";

export const ContactUsCard = () => (
  <div className="contact-us-card">
    <h4>Need a hand?</h4>
    <p>We're available</p>
    <p><strong>{officeHours}</strong></p>
    <ul className="contact-us-card__details">
      <li><a href="tel:+441173257898"><img src="/images/flags/currency/GBP.png" height={13} />+44 (0)117 325 7898</a></li>
      <li><a href="tel:+18884549902"><img src="/images/flags/currency/USD.png" height={13} />+1 888 454 9902</a></li>
      <li><a href="mailto:team@travellocal.com"><i className="icon icon-envelop5" />team@travellocal.com</a></li>
    </ul>
  </div>
);
